import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { UpsellTag } from "@devowl-wp/react-cookie-banner-admin";
import { ConsentRecordBlocker } from "./blocker.js";
import { useStores } from "../../../../store/stores.js";
import { __, _i } from "../../../../utils/i18n.js";
const ConsentTableRecordPreview = observer(({ record, onPreview })=>{
    const { optionStore: { others: { isPro } } } = useStores();
    const [replayBlockerRecord, setReplayBlockerRecord] = useState(false);
    const { custom_bypass, blocker, recorder, forwarded, referer, design_version } = record;
    return custom_bypass ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                children: __("Bypassed banner")
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: _i(__("There is no preview for this consent, as it was given implicitly by {{strong}}%s bypass{{/strong}}.", record.custom_bypass_readable), {
                    strong: /*#__PURE__*/ _jsx("strong", {})
                })
            })
        ]
    }) : blocker > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                children: __("Content Blocker as at the time of consent")
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("The consent to the service was given via a content blocker. Below you can see how the content blocker looked like when the user consented.")
            }),
            isPro ? /*#__PURE__*/ _jsx(ConsentRecordBlocker, {
                record: record,
                replayBlockerRecord: replayBlockerRecord,
                replayFinished: ()=>setReplayBlockerRecord(false)
            }) : /*#__PURE__*/ _jsx(UpsellTag, {
                title: __("You want to see what was displayed to the visitor?"),
                tagText: __("Unlock preview"),
                testDrive: true,
                feature: "consent-preview-blocker",
                assetName: __("pro-modal/consent-preview-blocker.png"),
                description: __("We generate the content blocker that your visitor has seen from all settings, design preferences and services. You can see exactly how his or her consent was obtained and track clicks on buttons.")
            }),
            isPro && !!recorder && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        style: {
                            marginTop: 15
                        },
                        children: __("The process of how the website visitor interacted with the content blocker to give consent was recorded for documentation purposes. You can replay the interactions. Note that the dimensions of the content blocker and consent dialog do not have to be the same as the ones that were displayed to the website visitor, and the recording may not be fully accurate if, for example, you use custom CSS on your website or the visitor used a translating browser extension.")
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "button-primary button-large",
                        onClick: ()=>{
                            setReplayBlockerRecord(!replayBlockerRecord);
                        },
                        children: replayBlockerRecord ? __("Stop") : __("Replay interactions")
                    })
                ]
            })
        ]
    }) : forwarded > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                children: __("Forwarded consent")
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: _i(__("There is no preview for this consent, as it was given implicitly by forwarding the consent. The user has given his/her consent via {{a}}%s{{/a}}, and this consent has been forwarded automatically.", referer), {
                    a: /*#__PURE__*/ _jsx("a", {
                        href: referer,
                        rel: "noopener noreferrer",
                        target: "_blank"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                children: __("Cookie banner as at the time of consent")
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("Use the button below to see what the cookie banner looked like at the time of the user's consent. The services/groups selected there also look the way the user saw them. A button framed in red shows which button the user clicked on at the time of consent.")
            }),
            isPro ? /*#__PURE__*/ _jsx("button", {
                className: "button-primary button-large",
                onClick: ()=>{
                    onPreview(record, false);
                },
                disabled: record.tcf_string && design_version < 7,
                children: __("Open banner")
            }) : /*#__PURE__*/ _jsx(UpsellTag, {
                title: __("You want to see what was displayed to the visitor?"),
                tagText: __("Unlock preview"),
                testDrive: true,
                feature: "consent-preview-banner",
                assetName: __("pro-modal/consent-preview-banner.png"),
                description: __("We generate the cookie banner from all (design) settings and services that the visitor has seen. You can see exactly how consent was obtained and track clicks on buttons.")
            }),
            isPro && !!recorder && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        style: {
                            marginTop: 15
                        },
                        children: __("The process of how the website visitor interacted with the cookie banner to give consent was recorded for documentation purposes. You can replay the interactions. Note that the recording may not be fully accurate if, for example, you use custom CSS on your website or the visitor used a translating browser extension.")
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "button-primary button-large",
                        onClick: ()=>{
                            onPreview(record, true);
                        },
                        disabled: design_version < 6 || record.tcf_string && design_version < 7,
                        children: __("Replay interactions")
                    }),
                    design_version < 6 ? /*#__PURE__*/ _jsx("div", {
                        className: "notice notice-warning inline below-h2 notice-alt",
                        style: {
                            margin: "10px 0 0 0"
                        },
                        children: /*#__PURE__*/ _jsx("p", {
                            children: _i(__("This consent was documented with a Real Cookie Banner version prior to 3.10.0. Due to rework to comply with the {{aAct}}European Accessibility Act{{/aAct}}, interactions with the currently installed version of Real Cookie Banner are no longer playable. However, they are still documented in the consent export. If you need to play the interactions, please request an old Real Cookie Banner version from the {{aSupport}}support{{/aSupport}}."), {
                                aAct: /*#__PURE__*/ _jsx("a", {
                                    href: __("https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32019L0882"),
                                    rel: "noreferrer",
                                    target: "_blank"
                                }),
                                aSupport: /*#__PURE__*/ _jsx("a", {
                                    href: __("https://devowl.io/support/"),
                                    rel: "noreferrer",
                                    target: "_blank"
                                })
                            })
                        })
                    }) : record.tcf_string && design_version < 7 ? /*#__PURE__*/ _jsx("div", {
                        className: "notice notice-warning inline below-h2 notice-alt",
                        style: {
                            margin: "10px 0 0 0"
                        },
                        children: /*#__PURE__*/ _jsx("p", {
                            children: _i(__("This consent was documented with a Real Cookie Banner version prior to 4.1.0. Due to rework to comply with the TCF 2.2 standard, interactions with the currently installed version of Real Cookie Banner are no longer playable. However, they are still documented in the consent export. If you need to play the interactions, please request an old Real Cookie Banner version from the {{aSupport}}support{{/aSupport}}."), {
                                aSupport: /*#__PURE__*/ _jsx("a", {
                                    href: __("https://devowl.io/support/"),
                                    rel: "noreferrer",
                                    target: "_blank"
                                })
                            })
                        })
                    }) : null
                ]
            })
        ]
    });
});
export { ConsentTableRecordPreview };
